import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ContentHeader from "src/shared/content-header/content-header.component";
import SkeletonComponent from "src/shared/custom-spinner/skeleton.component";
import { safeAtob } from "src/shared/helpers/enode-decode-string";
import { getLocationBlockByCode } from "src/store/slices/location-block.slice";
import AnalyticsComponent from "./analytics.component";

const FloorplanAnalyticsComponent = () => {
  const dispatch = useDispatch();

  const params: any = useParams();
  const blockCode: any = params.blockCode ? safeAtob(params.blockCode) : null;
  const floor = params?.floor;

  useEffect(() => {
    dispatch(getLocationBlockByCode({ blockCode }));
  }, [blockCode]);

  const blockDetail = useSelector(
    (state: any) => state.locationBlock.locationBlockDetails
  );

  const isLoadingLocationBlockDetails = useSelector(
    (state: any) => state.locationBlock.isLoadingLocationBlockDetails
  );

  return (
    <>
      <Helmet>
        <title>
          {blockDetail?.blockName
            ? `${blockDetail?.blockName + "-" + floor} | Analytics`
            : "Analytics | Floor Plan"}
        </title>
      </Helmet>
      <div className="">
        <div className="header-container">
          <div className="title-container">
            <SkeletonComponent
              wrapperHeight="90px"
              skeletonHeight="50px"
              isLoading={isLoadingLocationBlockDetails}
            >
              {Object.keys(blockDetail).length ? (
                <ContentHeader
                  pageTitle={
                    floor
                      ? `${blockDetail?.blockName}, ${blockDetail?.street}, ${blockDetail?.siteName}, ${blockDetail?.blockCode} - ${floor}`
                      : `${blockDetail?.blockName}, ${blockDetail?.street}, ${blockDetail?.siteName}, ${blockDetail?.blockCode}`
                  }
                />
              ) : null}
            </SkeletonComponent>
          </div>
        </div>

        <div className="page">
          <div className="page-container mt-3">
            <AnalyticsComponent />
          </div>
        </div>
      </div>
    </>
  );
};

export default FloorplanAnalyticsComponent;
